



<!-- footer -->

<div *ngIf="windowWidth > 992; else elseTemplate">
  <app-footer-four></app-footer-four>
  <app-footer-two></app-footer-two>
  <app-footer-three></app-footer-three>
  <app-footer></app-footer></div>
<ng-template #elseTemplate>

  <mobile-footer-theme1></mobile-footer-theme1>
</ng-template>
